// extracted by mini-css-extract-plugin
export var bold = "_ri-0";